module.exports = __webpack_public_path__ + "img/STAY HIGH_logo.b9b47c00.png";